<template>
  <div>
    <div>
      <b-table id="table-charges" ref="table"
               :fields="tableFieldsCharges"
               :items="itemsCharges"
               :tbody-tr-class="rowClass"
               :thead-class="'row-header'"
               borderless
               class="light-border"
               striped>
        <template #cell(type)="data">
          {{ $t(data.value) }}
        </template>
        <template #cell(HT)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
        <template #cell(TVA)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
        <template #cell(TTC)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
      </b-table>
    </div>

    <div>
      <b-table id="table-lots" :fields="tableFieldsLots"
               :items="itemsLots"
               :tbody-tr-class="rowClass"
               :thead-class="'row-header'"
               borderless
               class="light-border"
               striped>
        <template #cell(lot)="data">
          {{ $t(data.value) }}
        </template>
        <template #cell(HT)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
        <template #cell(TVA)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
        <template #cell(TTC)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
      </b-table>
    </div>

    <div>
      <b-table id="table-global" :fields="tableFieldsGlobal"
               :items="itemsGlobal"
               :tbody-tr-class="rowClass"
               :thead-class="'row-header'"
               borderless
               class="light-border"
               striped>
        <template #cell(nom)="data">
          {{ $t(data.value) }}
        </template>
        <template #cell(taux)="data">
          <template v-if="data.value!==''"> {{ data.value + " %" }}</template>
        </template>
        <template #cell(TVA)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
        <template #cell(TTC)="data">
          <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
        </template>
      </b-table>
    </div>
  </div>

</template>

<script>
import ExcelJS from 'exceljs';
import {saveAs} from 'file-saver';

export default {
  name: "OperationBilanTable",

  props: {
    operationName: {
      type: String,
      default: ''
    },
    tableFieldsCharges: {
      type: Array,
      required: true
    },
    itemsCharges: {
      type: Array,
      required: true
    },
    tableFieldsLots: {
      type: Array,
      required: true
    },
    itemsLots: {
      type: Array,
      required: true
    },
    tableFieldsGlobal: {
      type: Array,
      required: true
    },
    itemsGlobal: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      cellStyle: {
        alignment: {vertical: 'middle', horizontal: 'center'},
        font: {name: 'Calibri', color: {argb: '000000'}},
        fill: {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFFFFF'}},
        border: {
          top: {style: 'thin', color: {argb: 'd6d2d2'}},
          left: {style: 'thin', color: {argb: 'd6d2d2'}},
          bottom: {style: 'thin', color: {argb: 'd6d2d2'}},
          right: {style: 'thin', color: {argb: 'd6d2d2'}}
        }
      },
    }
  },

  methods: {
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.status === 'title-section-margin') return 'row-title-section row-margin'
      if (item.status === 'title-section') return 'row-title-section'
      else if (item.status === 'total-primary') return 'row-total-primary'
      else if (item.status === 'total-grey') return 'row-total-grey'
      else if (item.status === 'subtitle') return 'bold-text main-red-color'
    },

    async exportToExcel() {
      let workbook = new ExcelJS.Workbook();

      let chargesWorksheet = workbook.addWorksheet('Charges');
      this.exportTableToWorksheet(chargesWorksheet, this.tableFieldsCharges, this.itemsCharges);

      let lotsWorksheet = workbook.addWorksheet('Lots');
      this.exportTableToWorksheet(lotsWorksheet, this.tableFieldsLots, this.itemsLots);

      let globalWorksheet = workbook.addWorksheet('Global');
      this.exportTableToWorksheet(globalWorksheet, this.tableFieldsGlobal, this.itemsGlobal);

      const buffer = await workbook.xlsx.writeBuffer();

      saveAs(new Blob([buffer]), `Bilan-${this.operationName}.xlsx`);
    },

    exportTableToWorksheet(worksheet, tableFields, tableItems) {
      worksheet.views.showGridLines = false;

      worksheet.columns = tableFields.map(field => {
        return {header: field.label, key: field.key, width: 20};
      });

      this.setHeaderStyle(worksheet.getRow(1));
      this.processTableItems(worksheet, tableItems);
    },

    setHeaderStyle(headerRow) {
      headerRow.height = 35;
      headerRow.eachCell(cell => {
        this.setCellStyle(cell, this.cellStyle);
        cell.font = {...this.cellStyle.font, bold: true, size: 12, color: {argb: '07153C'}};
      });
    },

    processTableItems(worksheet, tableItems) {
      tableItems.forEach((item, index) => {
        let translatedItem = this.translateItem(item);

        let newRow = worksheet.addRow(translatedItem);

        newRow.eachCell((cell, colNumber) => {
          newRow.height = 35;
          this.setCellStyle(cell, this.cellStyle);

          if (index === 0) {
          } else if (index % 2 === 0) {
            cell.fill = {type: 'pattern', pattern: 'solid', fgColor: {argb: 'EEEEEE'}};
          }

          if (translatedItem.type.includes('Total')) {
            this.setCellStyle(cell, {
              fill: {type: 'pattern', pattern: 'solid', fgColor: {argb: '07153C'}},
              font: {color: {argb: 'FFFFFF'}}
            });
          }

          if (colNumber === 1) {
            worksheet.getColumn(colNumber).width = worksheet.name === "Global" ? cell.value.length * 2 : cell.value.length * 1.5;
          }
          cell.numFmt = '#,##0 "€";[Red]\\-#,##0 "€"';

          this.setSpecialCellStyle(cell, item);
        });
      });
    },

    translateItem(item) {
      let translatedItem = {...item};
      translatedItem.type = this.$t(item.type);
      translatedItem.lot = this.$t(item.lot);
      translatedItem.nom = this.$t(item.nom);

      translatedItem.HT = item.HT !== '' ? this.removeWhitespace(item.HT) : item.HT;
      translatedItem.TTC = item.TTC !== '' ? this.removeWhitespace(item.TTC) : item.TTC;
      translatedItem.TVA = item.TVA !== '' ? this.removeWhitespace(item.TVA) : item.TVA;
      if (typeof item.taux === 'number') {
        translatedItem.taux = item.taux + ' %';
      }

      return translatedItem;
    },

    setCellStyle(cell, style) {
      Object.assign(cell, style);
    },

    setSpecialCellStyle(cell, item) {
      if (item.status === 'title-section') {
        this.setCellStyle(cell, {font: {name: 'Calibri', color: {argb: '07153C'}, bold: true, size: 12}});
      } else if (item.status === 'total-primary') {
        this.setCellStyle(cell, {
          font: {name: 'Calibri', color: {argb: 'FFFFFF'}, bold: true},
          fill: {type: 'pattern', pattern: 'solid', fgColor: {argb: '07153C'}}
        });
      } else if (item.status === 'subtitle') {
        this.setCellStyle(cell, {font: {name: 'Calibri', color: {argb: '9E0430'}, bold: true}});
      }
    },

    removeWhitespace(input) {
      if (typeof input === 'string') {
        return Number(input.replace(/\s+/g, ''));
      } else {
        return input;
      }
    },
  }
}
</script>

<style scoped>

#table-charges tbody tr:nth-of-type(odd),
#table-lots tbody tr:nth-of-type(odd),
#table-global tbody tr:nth-of-type(odd) {
  background-color: #EEEEEE;
}

</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/OperationBilanTable.vue